<script setup lang="ts">
import { ElNotification } from 'element-plus'
import { ModeEnum } from '@/types/enums'

const { t } = useI18n()
const { updateMode, resetPasswordEmail } = siteUtils
const loading = ref(false)
resetPasswordEmail.value = ''
function handleForgotPasswordResponse(status: string) {
  switch (status) {
    case 'confirm_email':
      ElNotification({
        title: t('forgotPassword.notify.codeSent.title'),
        duration: 9000,
        offset: 100,
        appendTo: '#auth-wrapper',
        type: 'info',
        customClass: 'right-1/2 translate-x-1/2 large absolute'
      })
      updateMode(ModeEnum.resetPassword)
      break
    case 'user_not_found':
      ElNotification({
        title: t('forgotPassword.notify.userNotFound.title'),
        type: 'error',
        duration: 9000,
        offset: 100,
        appendTo: '#auth-wrapper',
        customClass: 'right-1/2 translate-x-1/2 large absolute'
      })
      break
    default:
      ElNotification({
        title: t('forgotPassword.notify.unavailable.title'),
        message: t('forgotPassword.notify.unavailable.message'),
        type: 'error',
        duration: 9000,
        offset: 100,
        appendTo: '#auth-wrapper',
        customClass: 'right-1/2 translate-x-1/2 large absolute'
      })
  }
}
function onSubmit(data: FormTypes.SubmitForm) {
  const { getGoatApiUrl } = siteUtils
  const { getAxiosInstance, catchError } = appUtilsPlugin
  loading.value = true
  ElNotification.closeAll()
  getAxiosInstance()
    ?.post(getGoatApiUrl('reset-password'), { ...data.form })
    .then((response) => {
      resetPasswordEmail.value = data.form?.email || ''
      handleForgotPasswordResponse(response?.data?.status || '')
    })
    .catch((err) => {
      catchError({ appendTo: '#auth-wrapper' })(err)
    })
    .then(() => {
      loading.value = false
    })
}
</script>

<template>
  <div
    class="box-form-wrapper mx-auto max-w-2xl big:max-w-(--breakpoint-xl) big:px-16 mt-5"
  >
    <div
      class="box-form big:mt-10 mx-3 bg-white pt-10 big:pt-16 pb-10 big:pb-16 px-2 big:px-16 rounded-2xl flex flex-col items-center"
    >
      <div class="mx-auto w-full max-w-md">
        <h1 class="text-lg big:text-2xl uppercase font-semibold text-center tracking-wider ">
          {{ t('forgotPassword.title') }}
        </h1>
        <goat-form-component
          class="mt-6 big:mb-5 w-full"
          size="large"
          hide-required-asterisk
          @submit="onSubmit"
        >
          <template #default="{ submit, form }">
            <goat-form-field-text-trim
              v-focus
              api-field-name="email"
              :placeholder="t('form.email')"
              :label="!!form?.email?.length ? t('form.email') : false"
              class="mt-1 big:mt-1.5 text-lg"
              required
              :rules="[{ type: 'email', trigger: 'blur', message: t('form.validation.notValidEmail') }]"
              @keyup.enter.stop.prevent="submit"
            />
            <goat-form-fields-group>
              <div class="mb-6 px-2">
                {{ t('forgotPassword.description') }}
              </div>
            </goat-form-fields-group>
            <goat-form-fields-group
              justify="space-between"
            >
              <el-button
                type="info"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                @click="updateMode(ModeEnum.login)"
              >
                {{ t('forgotPassword.cancelBtn') }}
              </el-button>
              <el-button
                type="primary"
                class="text-white rounded-lg uppercase text-lg w-[46%]"
                size="large"
                :loading="loading"
                @click="submit()"
              >
                {{ t('forgotPassword.sendEmailBtn') }}
              </el-button>
            </goat-form-fields-group>
          </template>
        </goat-form-component>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
</style>
